import claimsHttpRequestHandler from 'src/utils/ClaimsHttpRequestHandler';
import convertModelToQueryString from 'src/utils/convertModelToQueryString';

class ClaimsDocumentService {
  setAxiosInterceptors = ({ onLogout }) => {
    claimsHttpRequestHandler.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          this.setSession(null);

          if (onLogout) {
            onLogout();
          }
        }
        return Promise.reject(error);
      }
    );
  };

  setSession = accessToken => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      claimsHttpRequestHandler.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('accessToken');
      delete claimsHttpRequestHandler.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  uploadFile = async (file, claimId, documentAttribute) => {
    let formData = new FormData();
    formData.append('file', file);

    const qs = convertModelToQueryString(documentAttribute);

    const response = await claimsHttpRequestHandler.post(`/claim/${claimId}/document?${qs}`, formData);
    return response;
  };



  getDocumentData = async (claimId) => {
    const response = await claimsHttpRequestHandler.get(`/claim/${claimId}/documentData`);
    return response;
  }
}

const claimsDocumentService = new ClaimsDocumentService();
claimsDocumentService.setSession(claimsDocumentService.getAccessToken());

export default claimsDocumentService;